<template>
  <div class="d-flex flex-column flex-gap-lg">
    <div v-if="$checkAccountType($AccountTypes.APPLICANT)">
      <h5 :class="customClass.header">
        Employer Details
      </h5>

      <div>
        <b-avatar
          class="block"
          :src="
            $isEmpty(details.job_company_details.company_image)
              ? require('@/assets/images/placeholder/no-image.jpg')
              : details.job_company_details.company_image_url
          "
        />
        {{ details.job_company_details.company_name }}
      </div>

      <div>
        {{ details.job_company_details.company_summary }}
      </div>
    </div>

    <div>
      <h5 :class="customClass.header">
        Job Details
      </h5>

      <div class="d-flex flex-column flex-gap-md">
        <div>
          <div :class="customClass.detailLabel">
            Position
          </div>
          <div :class="customClass.detailInfo">
            {{ details.position }}
          </div>
        </div>

        <div v-if="details.published_fields.includes('salary') || $checkAccountType($AccountTypes.AGENCY) || $checkAccountType($AccountTypes.EMPLOYER)">
          <div :class="customClass.detailLabel">
            Salary
          </div>
          <div :class="customClass.detailInfo">
            {{ details.salary_currency }} {{ $thousandSeparated(details.min_salary) }} - {{ $thousandSeparated(details.max_salary) }} / {{ details.salary_cycle }}
          </div>
        </div>

        <div>
          <div :class="customClass.detailLabel">
            Working Days
          </div>
          <div :class="customClass.detailInfo">
            {{ details.working_days || '-' }}
          </div>
        </div>

        <div>
          <div :class="customClass.detailLabel">
            Working Hours
          </div>
          <div :class="customClass.detailInfo">
            {{ details.working_time || '-' }}
          </div>
        </div>

        <div>
          <div :class="customClass.detailLabel">
            Job Type
          </div>
          <div :class="customClass.detailInfo">
            {{ $capitalizeString(details.job_type) }}
          </div>
        </div>

        <div>
          <div :class="customClass.detailLabel">
            Employment Type
          </div>
          <div :class="`${customClass.detailInfo} d-flex flex-wrap flex-gap-sm`">
            <b-badge
              v-for="employment_type in details.employment_type"
              :key="employment_type.key"
            >
              {{ $capitalizeString(employment_type.replace('_', ' ')) }}
            </b-badge>
          </div>
        </div>


        <div>
          <div :class="customClass.detailLabel">
            Working Location
          </div>
          <div :class="customClass.detailInfo" style="white-space: pre-wrap;">
            {{ workingLocationTypeOptions.find((option =>{ return  option.value === details.working_location_type})).text || '-' }}
            {{
              details.working_location_type !== 'remote_only'
                ? `\n${details.working_location_address} \n${details.working_location_postal_code}, ${details.working_location_state}`
                : ''
            }}
          </div>
        </div>

        <div>
          <div :class="customClass.detailLabel">
            Descriptions
          </div>
          <div :class="customClass.detailInfo">
            {{ details.description }}
          </div>
        </div> 

        <div>
          <div :class="customClass.detailLabel">
            Requirements
          </div>
          <div :class="customClass.detailInfo">
            {{ details.requirements }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {
  workingLocationTypeOptions,
} from '@/constants/datastore'

export default {
  props: {
    details: {
      type: Object,
      default: () => {},
    },  
  },

  data() {
    return {
      workingLocationTypeOptions,

      customClass: {
        header: 'font-weight-bolder text-primary',
        detailLabel: 'font-weight-bolder',
        detailInfo: 'ml-1',
      }
    }
  },

  created() {
    //
  },
}
</script>

<style lang="scss" scoped>

</style>